export default __webpack_public_path__ + "static/media/lactancia.cfab2f6d.svg";